<template>
  <div
    class="link-wrapper d-flex cursor-pointer font-size-big"
    :class="{
      'color-post-tint font-weight-bold': isActive,
      'color-wall-tint font-weight-bold': isActive && !$vuetify.display.mobile
    }"
  >
    <v-list-item
      v-bind="navigationItem.external ? { href: navigationItem.link, target: '_blank' } : { to: navigationItem.link }"
      class="link pl-0"
      :class="{
        'font-weight-bold': $vuetify.display.mobile
      }"
      :ripple="false"
    >
      <div class="d-flex align-center">
        <div v-if="$slots.active || $slots.inactive" class="pl-4" />
        <slot v-if="isActive" name="active" />
        <slot v-else name="inactive" />
        <span class="ml-4">{{ navigationItem.title }}</span>
      </div>
    </v-list-item>
  </div>
</template>

<script>
export default {
  props: {
    navigationItem: {
      type: Object,
      required: true
    }
  },
  computed: {
    isActive() {
      if (this.navigationItem.link.name === this.$route.name) {
        if (this.navigationItem.link.params) {
          return Object.keys(this.navigationItem.link.params).every((key) => this.navigationItem.link.params[key] === this.$route.params[key])
        }
        return true
      }

      return (
        this.isActiveOnRootPage ||
        this.navigationItem.link.path === this.$route.path ||
        this.navigationItem.link === this.$route.path ||
        this.isActiveWithinSettings
      )
    },
    isActiveWithinSettings() {
      return (
        this.navigationItem.link.name === this.$routes.PROFILE_SETTINGS &&
        [this.$routes.PROFILE_SETTINGS_EMAILS, this.$routes.PROFILE_SETTINGS_PUSH_NOTIFICATIONS].includes(this.$route.name)
      )
    },
    isActiveOnRootPage() {
      return this.navigationItem.link.name === this.$routes.ROOT && this.$routerState.isRoot
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.v-list-item--link:before) {
  display: none;
}

.link-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.link {
  display: flex;
  align-items: center;
  height: 48px;
  width: 100%;

  &:focus,
  &:hover {
    outline: none;
    background-color: var(--wall-detail-10);
    border-radius: var(--rounded-app);
  }
}
</style>
